<template>
  <section class="flex flex-column flex-justify-start p-2">
    <article class="flex flex-column flex-justify-start flex-align-start">
      <h1>{{ $t('header.about') }}</h1>
    </article>

    <article class="flex flex-column flex-justify-center flex-align-start">
      <div class="justify-content-60">
        <p>
          {{ $t('about.article_1_text_1') }}.
        </p>
        <p>
          {{ $t('about.article_1_text_2') }}
        </p>
      </div>
    </article>

    <article class="flex flex-column flex-justify-center flex-align-start">
      <div class="justify-content-60">
        <div class="about-card flex flex-align-center">
          <div class="flex">
            <h4>
              {{ $t('about.article_2_title') }}
            </h4>
            <p>
              Julio Cesar Scheidt
            </p>
            <p>
              {{ $t('about.article_2_text_1') }}
            </p>
            <div>
              <img src="assets/images/aws-certification-solutions-architect-logo-v2.png" alt="saa" class="about-card-cert-image">
              <img src="assets/images/aws-certification-developer-associate-logo-v2.png" alt="dva" class="about-card-cert-image">
              <img src="assets/images/oci-certification-logo.png" alt="founder" class="about-card-cert-image">
              <img src="assets/images/terraform-associate.png" alt="terraform associate" class="about-card-cert-image">
              <img src="assets/images/microsoft-azure-fundamentals.png" alt="azure fundamentals" class="about-card-cert-image">
            </div>
          </div>

          <div class="flex">
            <a href="https://linktr.ee/julioscheidt" target="_blank">
              <img src="assets/images/founder.png" alt="Founder" class="about-round-image">
            </a>
          </div>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([]),
  },
  data() {
    return {}
  },
  methods: {},
  beforeDestroy() {}
}
</script>

<style scoped>
section {
  min-height: calc(100vh - 80px);
  width: auto;
}

section > article {
  height: auto;
  padding: 10px;
}

section > article > p {
  font-size: 14px;
}

.about-card {
  width: 100%;
  max-height: 550px;
  padding: 20px;
  flex-direction: row;
  justify-content: flex-start;
  background: #efefef;  /* fallback for old browsers */
  background: -webkit-linear-gradient(145deg, #efefef 70%, #fff 100%);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(145deg, #efefef 70%, #fff 100%); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  animation: slide-up 1s ease;
}

.about-card > div {
  width: 50%;
  flex-direction: column;
  align-items: flex-start;
}

.about-card > div:nth-child(2n) {
  align-items: center;
}

.about-round-image {
  width: 100px;
  height: 100px;
  margin: 50px;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, .25);
  /* border: 1px solid #f22; */
}

.about-card-cert-image {
  width: 70px;
  height: auto;
}

@media only screen and (max-width: 991px) {
  .about-card {
    flex-direction: column;
    justify-content: center;
  }

  .about-card > div {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }

  .about-card > div > div {
    text-align: center;
  }
}
</style>